(function () {
  'use strict';
  var coll = document.querySelector('[data-coll]');
  if (!coll) return;
  var form = coll.querySelector('[data-coll-form]');
  var overlay = coll.querySelector('[data-coll-overlay]');
  var sortSelect = coll.querySelector('[data-coll-sort]');
  var desktop = window.matchMedia('(min-width: 750px)');

  function open(which) {
    coll.classList.add(which === 'filter' ? 'is-filter-open' : 'is-sort-open');
    if (overlay) overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeAll() {
    var filtreAcikti = coll.classList.contains('is-filter-open');
    coll.classList.remove('is-filter-open', 'is-sort-open');
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = '';
    // Baymard #20: panel ✕ / dışına dokunarak kapatılınca seçim sessizce atılmasın — değiştiyse uygula
    if (filtreAcikti && !desktop.matches && degisti()) form.submit();
  }

  // --- Mobil panel: "N ürünü göster" (Baymard 2. tur #20) ---
  var applyBtn = coll.querySelector('.coll__apply');
  function formQS() { return form ? new URLSearchParams(new FormData(form)).toString() : ''; }
  var baslangic = formQS();
  function degisti() { return !!form && formQS() !== baslangic; }
  var sayiZaman, sayiAbort;
  // Çeviri (theme.liquid window.PETIDI_T; Türkçede boş → varsayılan)
  var T = window.PETIDI_T || {};
  function tt(k, d, o) { var s = T[k] || d; if (o) Object.keys(o).forEach(function (x) { s = s.split('[' + x + ']').join(o[x]); }); return s; }
  function tn(k, n, d, o) { o = o || {}; o.n = n; return tt(k + (n === 1 ? '.one' : '.other'), d, o); }
  var arama = coll.classList.contains('coll--arama');
  function sayiGetir() {
    if (!applyBtn || !form) return;
    clearTimeout(sayiZaman);
    sayiZaman = setTimeout(function () {
      if (sayiAbort) sayiAbort.abort();
      sayiAbort = 'AbortController' in window ? new AbortController() : null;
      applyBtn.textContent = tt('hesaplaniyor', 'Hesaplanıyor…');
      applyBtn.disabled = false;
      var sid = coll.getAttribute('data-section-id');
      var url = (form.getAttribute('action') || location.pathname) + '?' + formQS() + (sid ? '&section_id=' + encodeURIComponent(sid) : '');
      fetch(url, sayiAbort ? { signal: sayiAbort.signal } : {}).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      }).then(function (html) {
        var m = html.match(/data-total="(\d+)"/);
        if (!m) { applyBtn.textContent = tt('uygula', 'Uygula'); return; }
        var n = +m[1];
        applyBtn.textContent = n > 0 ? (arama ? tn('n_sonucu_goster', n, '[n] sonucu göster') : tn('n_urunu_goster', n, '[n] ürünü göster')) : tt('sonuc_yok_degistir', 'Sonuç yok — seçimi değiştir');
        applyBtn.disabled = n === 0;
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        applyBtn.textContent = 'Uygula';
      });
    }, 250);
  }

  function on(sel, ev, fn) {
    var el = coll.querySelector(sel);
    if (el) el.addEventListener(ev, fn);
  }
  // Mobil çipler (snippets/filtre-cipleri): birden çok açma düğmesi; filtre çipi paneli o gruba kaydırır
  coll.querySelectorAll('[data-coll-filter-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      open('filter');
      var i = b.getAttribute('data-fgroup-git');
      var panel = coll.querySelector('[data-coll-filters]');
      if (!panel) return;
      if (i === null) { panel.scrollTop = 0; return; }
      var g = panel.querySelectorAll('.fgroup')[+i];
      var head = panel.querySelector('.coll__sheet-head');
      if (g) panel.scrollTop = g.offsetTop - (head ? head.offsetHeight : 0);
    });
  });
  coll.querySelectorAll('[data-coll-sort-open]').forEach(function (b) {
    b.addEventListener('click', function () { open('sort'); });
  });
  on('[data-coll-filters-close]', 'click', closeAll);
  on('[data-coll-sort-close]', 'click', closeAll);
  if (overlay) overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  // Uygula: anında kilit + gösterge (ikinci basış işlem yapmaz)
  if (form && applyBtn) form.addEventListener('submit', function () {
    applyBtn.classList.add('is-loading'); applyBtn.textContent = tt('uygulaniyor', 'Uygulanıyor…');
    setTimeout(function () { applyBtn.disabled = true; }, 0);
  });

  // Masaüstünde filtre değişince otomatik uygula
  // Fiyat hazır aralıkları (snippets/filtre-fiyat, 17 Eki 2026): tek seçim; seçili olana tekrar basmak kaldırır.
  // Kutular ad taşımaz; gönderilen asıl alanlar gizli gte/lte (boşken disabled → adrese boş parametre gitmez).
  function fiyatSec(inp) {
    var grup = inp.closest('.fgroup__body') || coll;
    grup.querySelectorAll('[data-fiyat]').forEach(function (o) { if (o !== inp) o.checked = false; });
    ['gte', 'lte'].forEach(function (k) {
      var h = grup.querySelector('[data-fiyat-gizli="' + k + '"]');
      if (!h) return;
      var v = inp.checked ? (inp.getAttribute('data-' + k) || '') : '';
      h.value = v; h.disabled = v === '';
    });
  }
  coll.querySelectorAll('[data-coll-input]').forEach(function (inp) {
    inp.addEventListener('change', function () {
      if (inp.hasAttribute('data-fiyat')) fiyatSec(inp);
      if (desktop.matches && form) form.submit(); else sayiGetir();
    });
  });
  // Sıralama seçimi (masaüstü select)
  if (sortSelect) sortSelect.addEventListener('change', function () { if (form) form.submit(); });
  // Sıralama seçimi (mobil alt panel)
  coll.querySelectorAll('[data-sort-value]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (sortSelect) sortSelect.value = btn.getAttribute('data-sort-value');
      if (form) form.submit();
    });
  });

  // Sonsuz kaydırma (infinite scroll)
  var grid = coll.querySelector('[data-coll-grid]');
  var sentinel = coll.querySelector('[data-coll-sentinel]');
  var loading = false;

  // Stoğu tükenen ürünler en altta (seçili sıralama — ör. en çok satan — korunur).
  // İlk sayfayı Liquid zaten bu sırayla basıyor. Sonsuz kaydırmada gelen
  // kartlar yerleştirilirken MEVCUT kartlar yerinden oynatılmaz (CLS): stokta
  // olanlar ilk tükenen hücrenin önüne, tükenenler en sona eklenir.
  function isSold(cell) {
    var card = cell.querySelector('.pcard[data-available]');
    return !!(card && card.getAttribute('data-available') === 'false');
  }
  function firstSoldCell() {
    for (var i = 0; i < grid.children.length; i++) {
      if (isSold(grid.children[i])) return grid.children[i];
    }
    return null;
  }
  function appendCells(cells) {
    var avail = document.createDocumentFragment();
    var sold = document.createDocumentFragment();
    for (var i = 0; i < cells.length; i++) (isSold(cells[i]) ? sold : avail).appendChild(cells[i]);
    grid.insertBefore(avail, firstSoldCell());
    grid.appendChild(sold);
  }

  // Section Rendering API: tüm sayfa yerine yalnız bu bölümün HTML'i gelir —
  // ayrıştırma (DOMParser) çok küçülür, ana iş parçacığı dokunuşa daha çabuk döner (INP).
  var sectionId = coll.getAttribute('data-section-id');
  function nextUrl() {
    var a = sentinel ? sentinel.querySelector('[data-coll-next]') : null;
    var href = a ? a.getAttribute('href') : null;
    if (!href || !sectionId) return href;
    return href + (href.indexOf('?') >= 0 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
  }

  // Baymard 2. tur #19 (17 Eki 2026): ilk 2 sayfa kendiliğinden yüklenir, sonrası "Daha fazla ürün (N kaldı)" düğmesi
  // (altbilgiye ulaşılır). Kaç sayfa yüklendiği + tıklanan kart sessionStorage'da; ürüne gidip "Geri" gelince eksik
  // sayfalar sırayla çekilir ve aynı karta, ekranda aynı yüksekliğe kaydırılır.
  var OTO_SAYFA = 3;                                   // 1. sayfa + 2 otomatik yükleme
  var toplam = parseInt(coll.getAttribute('data-total'), 10) || 0;
  var ilkSayfa = parseInt(coll.getAttribute('data-page'), 10) || 1;
  var yuklenen = ilkSayfa;                              // ekrandaki son sayfa no
  var geriAnahtar = 'collGeri:' + location.pathname + location.search;
  var geriYukleniyor = false;

  function dugmeYaz() {
    if (!sentinel) return;
    var a = sentinel.querySelector('[data-coll-next]');
    if (!a) return;
    var kalan = toplam && grid ? toplam - grid.children.length : 0;
    var temel = a.getAttribute('data-etiket') || a.textContent.replace(/\s*\(.*\)\s*$/, '');
    a.setAttribute('data-etiket', temel);
    a.textContent = kalan > 0 ? tt('n_kaldi', '[e] ([n] kaldı)', { e: temel, n: kalan }) : temel;
    sentinel.classList.toggle('is-dugme', yuklenen >= OTO_SAYFA);
  }

  function loadMore() {
    if (loading || !grid || !sentinel) return Promise.resolve(false);
    var url = nextUrl();
    if (!url) return Promise.resolve(false);
    loading = true;
    sentinel.classList.add('is-loading');
    var a = sentinel.querySelector('[data-coll-next]');
    if (a) a.setAttribute('aria-busy', 'true');
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('[data-coll-grid]');
      if (newGrid) appendCells(Array.prototype.slice.call(newGrid.children));
      // Arama: sayfa/blog sonuçları ayrı listede (main-search "Yazılar ve sayfalar")
      var newDiger = doc.querySelector('[data-coll-diger]');
      var diger = coll.querySelector('[data-coll-diger]');
      if (newDiger && diger) Array.prototype.slice.call(newDiger.children).forEach(function (li) { diger.appendChild(li); });
      yuklenen++;
      var newSentinel = doc.querySelector('[data-coll-sentinel]');
      if (newSentinel) {
        sentinel.innerHTML = newSentinel.innerHTML;
      } else {
        if (io) io.disconnect();
        sentinel.remove();
        sentinel = null;
      }
      loading = false;
      if (sentinel) { sentinel.classList.remove('is-loading', 'is-hata'); dugmeYaz(); if (!geriYukleniyor) maybeLoad(); }
      return true;
    }).catch(function () {
      loading = false;
      if (sentinel) {
        sentinel.classList.remove('is-loading');
        sentinel.classList.add('is-hata', 'is-dugme');   // otomatik denemeyi bırak, düğme + hata yazısı
        var b = sentinel.querySelector('[data-coll-next]');
        if (b) { b.removeAttribute('aria-busy'); b.textContent = tt('yuklenemedi_tekrar', 'Yüklenemedi — tekrar dene'); }
      }
      return false;
    });
  }

  // Sentinel hâlâ görünürdeyse (kısa listeler) tekrar yükle — yalnız otomatik sayfa sınırına kadar
  function maybeLoad() {
    if (!sentinel || yuklenen >= OTO_SAYFA || sentinel.classList.contains('is-hata')) return;
    var rect = sentinel.getBoundingClientRect();
    if (rect.top < (window.innerHeight + 600)) loadMore();
  }

  var io = null;
  if (sentinel && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !geriYukleniyor && yuklenen < OTO_SAYFA && !sentinel.classList.contains('is-hata')) loadMore();
      });
    }, { rootMargin: '600px 0px' });
    io.observe(sentinel);
  }
  // Düğme (ve JS'siz bağlantı): tıklayınca yükle
  coll.addEventListener('click', function (e) {
    var a = e.target.closest('[data-coll-next]');
    if (!a || !sentinel || !sentinel.contains(a)) return;
    e.preventDefault();
    if (loading) return;                                // ikinci basış işlem yapmaz
    sentinel.classList.remove('is-hata');
    loadMore();
  });
  dugmeYaz();

  // --- Geri dönüşte yer (sessionStorage) ---
  function kaydet(hucre) {
    if (!grid) return;
    var veri = { s: yuklenen, y: window.scrollY, t: Date.now() };
    if (hucre) {
      veri.i = Array.prototype.indexOf.call(grid.children, hucre);
      veri.top = hucre.getBoundingClientRect().top;
    }
    try { sessionStorage.setItem(geriAnahtar, JSON.stringify(veri)); } catch (err) {}
  }
  if (grid) {
    grid.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      var hucre = a.closest('.coll__cell');
      if (hucre && hucre.parentNode === grid) kaydet(hucre);
    }, true);
  }
  window.addEventListener('pagehide', function () {
    var eski = null;
    try { eski = JSON.parse(sessionStorage.getItem(geriAnahtar) || 'null'); } catch (err) {}
    // karta tıklanarak çıkıldıysa onu koru; değilse yalnız sayfa sayısı + konum
    if (eski && eski.i != null && Date.now() - eski.t < 3000) { eski.s = yuklenen; eski.y = window.scrollY; try { sessionStorage.setItem(geriAnahtar, JSON.stringify(eski)); } catch (err) {} return; }
    kaydet(null);
  });

  var navTur = '';
  try { var ne = performance.getEntriesByType('navigation')[0]; navTur = ne ? ne.type : ''; } catch (err) {}
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  var geri = null;
  if ((navTur === 'back_forward' || navTur === 'reload')) {
    try { geri = JSON.parse(sessionStorage.getItem(geriAnahtar) || 'null'); } catch (err) {}
    if (geri && Date.now() - geri.t > 30 * 60 * 1000) geri = null;
  }
  function konumla() {
    var hucre = geri.i != null && grid ? grid.children[geri.i] : null;
    if (hucre) {
      var hedef = hucre.getBoundingClientRect().top + window.scrollY - (geri.top || 0);
      window.scrollTo(0, Math.max(0, hedef));
    } else {
      window.scrollTo(0, geri.y || 0);
    }
  }
  if (geri && geri.s > yuklenen && sentinel) {
    geriYukleniyor = true;
    coll.classList.add('is-geri');
    (function sonraki() {
      if (yuklenen >= geri.s || !sentinel) { geriYukleniyor = false; coll.classList.remove('is-geri'); konumla(); return; }
      loadMore().then(function (ok) {
        if (ok) sonraki();
        else { geriYukleniyor = false; coll.classList.remove('is-geri'); konumla(); }
      });
    })();
  } else if (geri) {
    konumla();
  }
})();

// Filtre grubunda "+ N daha" (main-collection.liquid, 13 Eki 2026): gizli seçenekleri aç/kapat. Filtreler AJAX ile
// yeniden çizildiği için olay belgeye bağlı.
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-fgroup-more]');
  if (!b) return;
  var g = b.closest('[data-fgroup]');
  if (!g) return;
  var acik = b.getAttribute('aria-expanded') === 'true';
  g.querySelectorAll('[data-fgroup-fazla]').forEach(function (el) { el.hidden = acik; });
  b.setAttribute('aria-expanded', acik ? 'false' : 'true');
  b.textContent = acik ? b.getAttribute('data-kapali') : b.getAttribute('data-acik');
});
